import { render } from "./Redirect.vue?vue&type=template&id=e0181ee6&scoped=true"
import script from "./Redirect.vue?vue&type=script&lang=js"
export * from "./Redirect.vue?vue&type=script&lang=js"

import "./Redirect.vue?vue&type=style&index=0&id=e0181ee6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0181ee6"]])

export default __exports__